import { EventSegmentationType } from '../../../../models/enums/event-segmentation-type.enum';
import { EventPlatform } from '../../../../models/enums/event-platform.enum';
import { EventRecurrence } from '../../../../models/enums/event-recurrence.enum';

export interface EventSegmentationTypeOption {
  value: EventSegmentationType;
  viewValue: string;
}

// Event Segmentation Type Options
export const eventSegmentationTypeOptions: EventSegmentationTypeOption[] = [
  { value: EventSegmentationType.AllStudents, viewValue: EventSegmentationType.AllStudents },
  { value: EventSegmentationType.RegisteredStudentsOnly, viewValue: EventSegmentationType.RegisteredStudentsOnly }
];

// Event Platform Options
export const eventPlatformOptions = [
  { value: EventPlatform.Custom, viewValue: EventPlatform.Custom },
  { value: EventPlatform.GoogleMeet, viewValue: EventPlatform.GoogleMeet },
  { value: EventPlatform.Discord, viewValue: EventPlatform.Discord }
];

// Event Recurrence Options
export const eventRecurrenceOptions = [
  { value: EventRecurrence.NotRepeating, viewValue: EventRecurrence.NotRepeating },
  { value: EventRecurrence.Weekly, viewValue: EventRecurrence.Weekly }
];
